import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IJiraIssue, IOpenIssues } from "@/models/jiraIssue/jiraIssue.types"
import { JiraIssue, OpenIncidents } from "@/models/jiraIssue/jiraIssue"

export const JiraIssueParser: IParser<IJiraIssue, IJiraIssue> = {
  toDomain: (data: IJiraIssue) => {
    try {
      return new JiraIssue(
        data.expand,
        data.fields,
        data.id,
        data.key,
        data.self,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const OpenIncidentsParser: IParser<IOpenIssues, IOpenIssues> = {
  toDomain: (data: IOpenIssues) => {
    try {
      return new OpenIncidents(
        data.issues,
        data.maxResults,
        data.startAt,
        data.total,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
